import React from 'react'
import { FormattedMessage } from 'react-intl';
import api from '../../../utils/API';
import './SSO-CMS.css'


class SSOResendVerificationEmail extends React.Component {
    state = {
        email: '',
        error: '',
        displayString: '',
        success: false,
        submitted: false,
      }
    componentDidMount() {
    }
    handleSubmit = () => {
        this.setState({ submitted: true, error: '', success: false});
        api.resendVerifyForCMSECreateAccount(this.state.email)
        .then((res) => {
            console.log('Successfully resent to', this.state.email);
            this.setState({ submitted: false, error: '', success: true, displayString:<FormattedMessage id="RESEND_VERIFICATION_EMAIL_SENT" />});       
        })
        .catch(err => {
            if(err.response && err.response.data){
                this.setState({ submitted: false, error: err.message })
            }else{
                this.setState({ submitted: false})
            }     
        })
    }
    render() {
        return(
            <div>
            {this.state.success ?
                <div className='card'>
                    <div className='header text-center'>
                        <h2><FormattedMessage id="RESEND_VERIFICATION_EMAIL" /></h2>
                    </div>
                    <div className='form-outline text-center mt-2 mb-2'>
                        {this.state.displayString ? <label className='form-label'>{this.state.displayString}</label> : null}
                    </div> 
                    <button type='button' className='btn btn-primary btn-block' onClick={this.props.onSignIn}><FormattedMessage id="DONE_BTN" /></button>
                </div> :
                <div className='card'>
                    <div className='header text-center'>
                    <h2><FormattedMessage id="RESEND_VERIFICATION_EMAIL" /></h2>
                    </div>            
                    <div className='form-outline mt-2 mb-2'>
                        <label className='form-label' id='emailAddressLabel' htmlFor='form2Example1'><FormattedMessage id="EMAIL_ADDRESS" /></label>
                        <input className='form-control rounded-1' id='emailAddressField' value={this.state.email} name='email' type='email' onChange={(e) => this.setState({email: e.target.value})} />
                    </div>
                    {this.state.error ? <p className='error'><FormattedMessage id="ERROR" />{this.state.error}</p> : null}
                    <button type='button' className='btn btn-primary btn-block' onClick={this.handleSubmit} disabled={this.state.submitted}><FormattedMessage id="SUBMIT"/></button>
                    {/*<div className='mt-2 text-center'>
                            <label className='form-label red ms-2 label_hover' onClick={this.props.onSignIn}><FormattedMessage id="LOG_IN" /></label>
                    </div>*/}
                </div>
            }
            </div>
        )
    }
}

export default SSOResendVerificationEmail;